import { useState } from 'react'
import { Navigate } from 'react-router-dom'
import { sileo } from 'sileo'
import DownloadIcon from '@mui/icons-material/Download'
import Layout from '../components/layouts/index'
import { Paper, Button } from '../components/modules/ui/index'
import { useQueryGetUserMe } from '../queries/userQueries'
import { canAccessMarketingReports } from '../constants/marketingReports'
import userApi from '../api/user.api'

export default function ReportesMarketing() {
  const { data: userMe, isLoading } = useQueryGetUserMe()
  const [isDownloading, setIsDownloading] = useState(false)

  const hasAccess = canAccessMarketingReports(userMe?.email)

  const handleDownload = async () => {
    setIsDownloading(true)
    try {
      const response = await userApi.downloadUsersBusinessesReport()
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const anchor = document.createElement('a')

      anchor.href = url
      anchor.download = 'reporte_usuarios_empresas.xlsx'
      document.body.appendChild(anchor)
      anchor.click()
      document.body.removeChild(anchor)
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Error al descargar el reporte de marketing:', error)
      sileo.error({
        title: 'Error de Descarga',
        description: 'No se pudo descargar el reporte 🤯'
      })
    } finally {
      setIsDownloading(false)
    }
  }

  if (isLoading) return null

  if (!hasAccess) return <Navigate to='/' replace />

  return (
    <Layout>
      <div className='p-4'>
        <Paper>
          <div className='p-6'>
            <h1 className='text-2xl font-bold mb-2'>Reportes Marketing</h1>
            <p className='text-sm text-gray-500 mb-6'>
              Descarga el reporte de usuarios y empresas en formato Excel.
            </p>

            <Button
              onClick={handleDownload}
              disabled={isDownloading}
              color='accent2'
              className='rounded-full'
              title={
                <span className='flex items-center gap-2'>
                  <DownloadIcon fontSize='small' />
                  {isDownloading ? 'Descargando...' : 'Descargar usuarios y empresas'}
                </span>
              }
            />
          </div>
        </Paper>
      </div>
    </Layout>
  )
}
